import { Result } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as NotFoundSvg } from 'assets/svgs/404.svg';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { useTranslation } from 'hooks/use-translation';

interface NotFoundProps extends ClassNameOnlyProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  linkTo: string;
  actionText: React.ReactNode | string;
}

export const NotFound: FC<Partial<NotFoundProps>> = (props) => {
  const defaultTitle = useTranslation('error.404.title');
  const defaultSubTitle = useTranslation('error.404.message');
  const defaultActionText = useTranslation('error.404.action');

  const {
    title = defaultTitle,
    subTitle = defaultSubTitle,
    linkTo = '/',
    actionText = defaultActionText,
    className,
  } = props;

  return (
    <Result
      className={className}
      title={title}
      icon={<NotFoundSvg />}
      subTitle={subTitle}
      extra={
        <Link to={linkTo} type="primary">
          {actionText}
        </Link>
      }
    />
  );
};
